const state = {
  image: {
    tags: [],
    action: null,
    context: {}
  },
  sound: {
    tags: [],
    action: null,
    context: {}
  }
}

const mutations = {
  open(state, { tags, action, context }) {
    state.image.tags = tags
    state.image.action = action
    state.image.context = context
  },
  close(state) {
    state.image.tags = []
    state.image.action = null
    state.image.context = {}
  },
  openSound(state, { tags, action, context }) {
    state.sound.tags = tags
    state.sound.action = action
    state.sound.context = context
  },
  closeSound(state) {
    state.sound.tags = []
    state.sound.action = null
    state.sound.context = {}
  }
}

const getters = {
  image(state) {
    return state.image
  },
  sound(state) {
    return state.sound
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}